import { useConfirm } from 'material-ui-confirm'
import React from 'react'
import { Profile, Subscription } from '../../../../Profile/types'
import { UnitMaster } from '../../../../Units/reducer'
import {
  ConfirmationButtonProps,
  ContentProps,
  DialogActionProps,
  TitleProps,
} from '../../config'
import { ChangeUnitDescription } from './description'
import { onConfirmCallback } from './onConfirm'

export const onChangeUnitCallback = ({
  selectedRow,
  profile,
  _individualUnits,
  subscriptions,
  onCloseUnitModal,
  onUnitChanged,
  onChangeStarted,
  onChangeFinished,
}: {
  selectedRow: UnitMaster | null
  profile: Profile
  _individualUnits: UnitMaster[]
  subscriptions: Subscription[]
  onCloseUnitModal: () => void
  onUnitChanged: (val: UnitMaster) => void
  onChangeStarted: () => void
  onChangeFinished: () => void
}) => {
  const confirm = useConfirm()

  const { onConfirmChange } = onConfirmCallback({
    _individualUnits,
    selectedRow,
    subscriptions,
    onCloseUnitModal,
    onUnitChanged,
  })

  const onChangeUnit = React.useCallback(
    (val: UnitMaster | null) => {
      confirm({
        title: <div>Change Unit for {profile?.fullName} ?</div>,
        description: (
          <ChangeUnitDescription val={val} selectedRow={selectedRow} />
        ),
        titleProps: TitleProps,
        dialogActionsProps: DialogActionProps,
        contentProps: ContentProps,
        confirmationButtonProps: ConfirmationButtonProps,
      })
        .then(async () => {
          onChangeStarted()
          try {
            await onConfirmChange(val)
          } finally {
            onChangeFinished()
          }
        })
        .catch(() => {
          console.log('canceled')
        })
    },
    [
      confirm,
      onChangeFinished,
      onChangeStarted,
      onConfirmChange,
      profile,
      selectedRow,
    ]
  )

  return {
    onChangeUnit,
  }
}
